import React from 'react';
import { useAutoLogout } from '../hooks/useAutoLogout';

const SessionController: React.FC = () => {
    useAutoLogout();
    return null;
};

export default SessionController;
